import { Component, HostListener, ViewChild } from "@angular/core";
import { AppSettings } from "./app.settings";
import { Settings } from "./app.settings.model";
import { Console } from "console";
import { AppOAuthStore } from "./models/AppOAuthSotarge";
import { httpConnect } from "./services/httpConnect.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  public settings: Settings;

  constructor(
    public appSettings: AppSettings,
    public appOAuthStore: AppOAuthStore,
    private httpConn: httpConnect,
    private _snack: MatSnackBar,
    private router: Router,
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    // Registra el evento unload manualmente en ngOnInit solo para dispositivos móviles
    if (this.isMobileDevice()) {
      window.addEventListener('unload', this.handleUnload.bind(this));
    }

  }

  // Se ejecuta este evento al momento de cerrar la pestaña o cerrar el navegador
  @HostListener('window:unload', ['$event'])
  doSomethingOnUnload($event: any): void {
    this.canDeactivate();
  }

  // Manejador del evento unload
  handleUnload(event: any): void {
    this.canDeactivate();
  }


  isMobileDevice(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }


  canDeactivate() {

    // Obtiene el ID de usuario después de limpiar la sesión
    const id_usuario: number = +this.appOAuthStore.getItem("id_usuario");

    // this.httpConn.postAPI('Seguridad', 'Logout', { id_usuario: id_usuario, date_logoutNav: date_logoutNav })
    this.httpConn.postAPI('Seguridad', 'Logout', { id_usuario: id_usuario })
      .subscribe(data => {
        this.appOAuthStore.clear();
        this.router.navigate(['/']);
        localStorage.clear();
        this.clearSession();
      }, error => {
        this._snack.open('Ocurrio un error al cerrar la sesion', null, { panelClass: ['snackbar-center-text'] });
      });
  }

  clearSession(): void {
    // Eliminar cookies
    this.deleteAllCookies();

    // Limpiar local storage
    this.appOAuthStore.clear();
    localStorage.clear();
  }

  deleteAllCookies(): void {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }
  }
}